.heroContent {
  position: absolute;
  top: 8vh;
  left: 50%;
  transform: translateX(-50%); /* centers horizontally */
  width: 90vw; /* fills most of the screen */
  max-width: 800px;
  padding: 3rem;
  box-sizing: border-box;
}

.heroContentWoodenRack {
  position: absolute;
  top: 14vh;
  left: 20%;
  transform: translateX(-50%); /* centers horizontally */
  width: 90vw; /* fills most of the screen */
  max-width: 600px;
  padding: 3rem;
  box-sizing: border-box;
}

.titleRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.heroTitle {
  font-size: 58px;
  font-weight: 200;
  margin: 0;
  color: #fffdf7;
  letter-spacing: 1.5px;
}

.heroSubtitle {
  font-size: 24px;
  font-weight: 200;
  letter-spacing: 0.6px;
  color: #fffdf7;
  margin: 2px 0;
  display: flex;
  flex-direction: row;
  gap: 10px;
  text-align: justify;
}

@media (max-width: 1400px) {
  .heroContent {
    top: 12vh;
    max-width: 630px;
  }

  .heroTitle {
    font-size: 44px;
  }

  .heroSubtitle {
    font-size: 20px;
  }

  .heroContentWoodenRack {
    max-width: 450px;
  }
}

@media (max-width: 678px) {
  .heroContent {
    top: 9vh;
  }
  .heroContentWoodenRack {
    top: 45%;
    left: 50%;
  }
}

@media (max-width: 480px) {
  .heroContent {
    top: 7vh;
    width: 87vw;
    padding: 1.5rem;
  }

  .heroContentWoodenRack {
    max-width: 370px;
  }

  .heroTitle {
    font-size: 24px;
  }

  .heroSubtitle {
    font-size: 18px;
  }
}

@media (max-width: 380px) {
  .heroContent {
    top: 4vh;
  }

  .heroTitle {
    font-size: 24px;
  }

  .heroSubtitle {
    font-size: 18px;
  }
}
